const translations = {
  // === NAVBAR & MENU ===
  'nav.beranda': '首页',
  'nav.tentangKami': '关于我们',
  'nav.portofolio': '项目案例',
  'nav.news': '新闻中心',
  'nav.karir': '人才招聘',
  'nav.kontak': '联系我们',
  'nav.hubungiKami': '联系我们',
  'nav.beranda2': '首页',

  // === HERO SECTION ===
  'hero.label': 'PT Waringin Mega Mandiri — 成立于2022年',
  'hero.title1': '值得信赖的',
  'hero.title2': '建筑',
  'hero.title3': '总承包商',
  'hero.subtitle': 'PT Waringin Mega Mandiri 是 Waringin 集团的子公司，业务涵盖店屋、工厂、仓库、酒店、公寓、餐厅、学校、办公室、高层建筑、住宅及工业园区建设。',
  'hero.lihatPortofolio': '查看案例',
  'hero.hubungiKami': '联系我们',
  'hero.scroll': '滚动',
  'hero.stat.tahunPengalaman': '年从业经验',
  'hero.stat.proyekSelesai': '已完工项目',
  'hero.stat.kepuasanKlien': '客户满意度',
  'hero.stat.klienKorporat': '企业客户',
  'hero.slogan': 'BUILD TO PERFECTION',

  // === SERVICES (LAYANAN) ===
  'services.label': '我们的专业领域',
  'services.titleHighlight': '我们的',
  'services.titleSuffix': '服务',
  'services.subtitle': '我们采用领先技术提供全面的建筑解决方案，以满足每个项目的需求。',
  'services.lingkupPekerjaan': '工程范围',
  'services.lingkupSubtitle': '我们专业承接的建筑领域',
  'services.keunggulan': '我们的优势',
  'services.mengapaWMM': '为何选择',
  'services.dukunganDesc': '我们获得 PT. Waringin Megah 的全力支持，确保每个项目顺利运行。',
  
  'service.gc.title': '总承包 (General Contractor)',
  'service.gc.tagline': '专业且值得信赖的建筑解决方案',
  'service.gc.description': 'PT. Waringin Mega Mandiri 是一家专业的总承包商，在中大型建筑项目方面拥有丰富经验。',
  'service.gc.scope1.title': '商业与办公楼宇',
  'service.gc.scope1.desc': '按照国际建筑标准建造商业楼宇、办公室和购物中心。',
  'service.gc.scope2.title': '住宅与房产',
  'service.gc.scope2.desc': '采用优质材料和精密工艺建造高端住宅、公寓和住宅区。',
  'service.gc.scope3.title': '公共设施与机构',
  'service.gc.scope3.desc': '建设公共设施、医院、学校和政府大楼。',
  'service.gc.scope4.title': '特殊与综合用途项目 (Mixed-Use)',
  'service.gc.scope4.desc': '承接高复杂度项目，包括综合用途开发项目。',
  'service.gc.why1': '来自 PT. Waringin Megah 的经验团队',
  'service.gc.why2': '结构化且透明的项目管理',
  'service.gc.why3': '对质量和准时交付的承诺',
  'service.gc.why4': '人力、设备和财务的全面支持',
  'service.gc.why5': '经过验证的项目履历',
  'service.gc.why6': '与客户积极沟通',
  'service.gc.stat1.val': '50+',
  'service.gc.stat1.label': '已完工项目',
  'service.gc.stat2.val': '100%',
  'service.gc.stat2.label': '客户满意度',
  'service.gc.stat3.val': '2022',
  'service.gc.stat3.label': '成立年份',
  'service.gc.cta': '项目咨询',
  'service.6.title': '服务与维护 (Service & Maintenance)',

  // === TENTANG KAMI (ABOUT PAGE) ===
  'about.title': '关于我们',
  'about.subtitle': '深入了解 PT Waringin Mega Mandiri — 一家以科技和诚信建设印度尼西亚的建筑公司。',
  'about.breadcrumb': '关于我们',
  'about.beranda': '首页',
  'about.fondasi': '我们的基础',
  'about.nilaiPerusahaan': '企业价值观',
  'about.perjalanan': '发展历程',
  'about.historyMilestone': '历史与里程碑',

  // === VISI & MISI ===
  'vm.label': '方向与目标',
  'vm.title': '愿景与',
  'vm.highlight': '使命',
  'vm.visi': '愿景',
  'vm.misi': '使命',
  'vm.visiQuote': '成为值得信赖的建筑服务公司，提供高质量产品，通过最优质的服务让客户满意。',
  'vm.misi1': '以极具竞争力的价格提供高质量的建筑服务产品。',
  'vm.misi2': '在支持公司的各个方面进行全面的可持续发展。',
  'vm.misi3': '为客户提供最优质的服务。',

  // === PROFIL PERUSAHAAN ===
  'profile.label': '公司简介',
  'profile.title': 'PT Waringin',
  'profile.highlight': 'Mega Mandiri',
  'profile.founded': '成立年份',
  'profile.p1': 'PT. Waringin Mega Mandiri 是一家总部位于雅加达的建筑服务/总承包公司，是 PT. Waringin Megah 的子公司。',
  'profile.p2': '成立于 2022 年，旨在管理此前由 PT. Waringin Megah 雅加达分公司管理的管理团队。',
  'profile.p3': '管理团队始终致力于提供高质量的作品，服务并满足所有客户。',
  'profile.kota': '业务覆盖雅加达',
  'profile.tenaga': '经验丰富的专业团队',
  'profile.proyek': '高质量项目',
  'profile.standar': '获得 PT. Waringin Megah 支持',

  // === NILAI PERUSAHAAN (VALUES) ===
  'values.label': '我们的基础',
  'values.title': '企业',
  'values.highlight': '价值观',
  'value.1.title': '诚信',
  'value.1.desc': '我们在业务和项目执行的每个方面都坚守诚实与透明。',
  'value.2.title': '质量',
  'value.2.desc': 'ISO 9001 高级质量标准贯穿每一道施工工序。',
  'value.3.title': '创新',
  'value.3.desc': '持续以最新 BIM 技术、无人机勘测和 AI 推动建筑项目管理。',
  'value.4.title': '协作',
  'value.4.desc': '与客户、顾问和分包商建立互利共赢的战略合作伙伴关系。',

  // === PORTOFOLIO ===
  'portfolio.title': '项目案例',
  'portfolio.subtitle': '我们在印度尼西亚各地建设知名建筑工程的业绩记录。',
  'portfolio.breadcrumb': '项目案例',
  'portfolio.semua': '全部',
  'portfolio.gedung': '建筑',
  'portfolio.infrastruktur': '基础设施',
  'portfolio.renovasi': '改建',
  'portfolio.industrial': '工业',
  'portfolio.statusSelesai': '已竣工',
  'portfolio.statusOngoing': '进行中',
  'portfolio.menampilkan': '显示',
  'portfolio.proyek': '个项目',
  'portfolio.dalamKategori': '分类：',
  'portfolio.konsultasiCta': '有意与我们合作？立即咨询您的项目需求。',
  'portfolio.konsultasiBtn': '项目方案咨询',
  'portfolio.tidakAda': '该类别暂无项目。',

  // === KARIR ===
  'karir.badge': '加入我们的团队',
  'karir.title1': '在此发展您的职业',
  'karir.title2': 'PT Waringin Mega Mandiri',
  'karir.subtitle': '加入我们的专业团队，成为印度尼西亚最优秀建设项目的一份子。',
  'karir.mengapa': '为何选择 WMM？',
  'karir.komunitas': '我们是一个共同成长的专业社区。',
  'karir.lowongan': '开放职位',
  'karir.posisiTerbuka': '个开放职位 — 寻找适合您专业技能的机会',
  'karir.semua': '全部',
  'karir.tidakAda': '目前暂无职位空缺。',
  'karir.tidakCocok': '没有找到合适的职位？',
  'karir.kirimSpontan': '主动投递您的简历。我们将第一时间与您联系。',
  'karir.kirimBtn': '主动投递简历',
  'karir.deskripsiPekerjaan': '职位描述',
  'karir.keuntungan': '福利待遇',
  'karir.kualifikasi': '任职要求',
  'karir.lamarSekarang': '立即申请',
  'karir.tanyaWA': '通过 WhatsApp 咨询',
  'karir.deadline': '截止日期',
  'karir.dept.manajemen': '项目管理',
  'karir.dept.teknologi': '技术与创新',
  'karir.dept.engineering': '工程',
  'karir.dept.estimasi': '估算与成本',
  'karir.dept.hse': '健康、安全与环境',
  'karir.dept.desain': '设计与制图',

  // === NEWS / BERITA ===
  'news.badge': '新闻与洞察',
  'news.title1': '新闻与',
  'news.title2': '动态',
  'news.subtitle': 'PT Waringin Mega Mandiri 项目、建筑技术及最新发展的实时资讯。',
  'news.artikelPilihan': '精选文章',
  'news.semua': '全部',
  'news.artikel': '篇文章',
  'news.tidakAda': '该类别暂无文章。',
  'news.newsletterTitle': '订阅新闻通讯',
  'news.newsletterSubtitle': '直接将 WMM 最新项目资讯送达您的收件箱。',
  'news.placeholder': '您的邮箱地址',
  'news.subscribe': '订阅',
  'news.subscribed': '订阅成功！',
  'news.bacaSelengkapnya': '阅读更多',

  // === TIM MANAJEMEN ===
  'team.label': '我们的领导团队',
  'team.title': '核心',
  'team.highlight': '团队',
  'team.subtitle': '由拥有丰富国内外建筑项目履历的资深专业人士领导。',
  'team.pendiri': '公司创始人',
  'team.direksi': '董事会',
  'team.orang': '人',
  'team.pos.pemegang': '股东',
  'team.pos.komisaris': '董事长',
  'team.pos.direktur': '总裁',
  'team.desc.1': '常驻泗水的开发商。1987年与 Ir. Yohanes Sucipto 共同创立 PT. Waringin Megah。',
  'team.desc.2': '1985年毕业于泗水彼得拉基督教大学土木工程系。共同创立 PT. Waringin Megah。',
  'team.desc.3': '1989年毕业于泗水 ITS 土木工程系。现任 PT. Waringin Mega Mandiri 董事长。',
  'team.desc.4': '1994年毕业于万隆马拉纳塔基督教大学土木工程系。现任 PT. Waringin Mega Mandiri 总裁。',

  // === KONTAK & FORM ===
  'kontak.heroBadge': '联系我们',
  'kontak.heroTitle1': '欢迎',
  'kontak.heroTitle2': '洽谈合作',
  'kontak.heroSubtitle': '我们随时准备帮助您实现梦想项目。免费咨询，快速响应。',
  'kontak.infoTitle': '联系信息',
  'kontak.infoSubtitle': '通过我们提供的任意渠道联系我们。',
  'kontak.address': '办公地址',
  'kontak.addressVal': 'Jl. Bendungan Hilir Raya G1 No.5 雅加达中心 10210',
  'kontak.addressSub': '在 Google 地图上查看',
  'kontak.phone': '电话',
  'kontak.phoneVal': '+62 21 5738001',
  'kontak.phoneSub': '周一 – 周六, 08.00–17.00 WIB',
  'kontak.email': '电子邮箱',
  'kontak.emailVal': 'info@waringinmegamandiri.com',
  'kontak.emailSub': '1个工作日内回复',
  'kontak.whatsapp': 'WhatsApp',
  'kontak.whatsappVal': '+62 812-3456-7890',
  'kontak.hours': '营业时间',
  'kontak.weekdays': '周一 – 周五',
  'kontak.weekdaysHours': '08.00 – 17.00 WIB',
  'kontak.saturday': '周六',
  'kontak.saturdayHours': '08.00 – 13.00 WIB',
  'kontak.sunday': '周日',
  'kontak.sundayHours': '休息',
  'kontak.formTitle': '发送消息',
  'kontak.formSubtitle': '请填写以下表单，我们的团队将尽快与您联系。',
  'kontak.name': '姓名',
  'kontak.namePlaceholder': '请输入您的姓名',
  'kontak.emailLabel': '电子邮箱',
  'kontak.emailPlaceholder': 'email@company.com',
  'kontak.phoneLabel': '电话号码',
  'kontak.phonePlaceholder': '+62 8xx-xxxx-xxxx',
  'kontak.company': '公司 / 机构',
  'kontak.companyPlaceholder': '您的公司名称（可选）',
  'kontak.projectType': '项目类型',
  'kontak.projectTypePlaceholder': '请选择项目类型',
  'kontak.budget': '预算估算',
  'kontak.budgetPlaceholder': '请选择预算范围',
  'kontak.message': '留言 / 项目描述',
  'kontak.messagePlaceholder': '请简要描述您的项目需求...',
  'kontak.submit': '发送消息',
  'kontak.submitting': '发送中...',
  'kontak.successTitle': '消息已发送！',
  'kontak.successMsg': '感谢您的留言！我们的团队将在1个工作日内与您联系。',
  'kontak.mapTitle': '我们的位置',
  'kontak.ctaTitle': '或直接通过 WhatsApp 联系',
  'kontak.ctaSubtitle': '通过 WhatsApp 获得更快的回复。',
  'kontak.ctaBtn': '通过 WhatsApp 咨询',
  'kontak.required': '必填',
  'kontak.charLimit': '最多 500 个字符',
  'kontak.sertifikasi': '资质与法律声明',
  'kontak.socialMedia': '社交媒体',
  'kontak.kembali': '返回',

  // === FOOTER ===
  'footer.perusahaan': '公司',
  'footer.layanan': '服务',
  'footer.kontak': '联系我们',
  'footer.desc': '建筑服务公司/总承包商，PT. Waringin Megah 的子公司，致力于提供最佳施工成果。',
  'footer.copyright': '© 2024 PT Waringin Mega Mandiri. 版权所有。',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',

  // === PROJECT CARD & MODAL ===
  'project.lihatDetail': '查看详情',
  'project.lokasi': '地点',
  'project.tahun': '年份',
  'project.klien': '客户',
  'project.nilai': '价值',
  'project.kategori': '类别',
  'project.status': '状态',
  'project.diskusi': '咨询类似项目',
  'project.tutup': '关闭',
  'project.statusSelesai': '已竣工',
  'project.statusOngoing': '进行中',
  'project.tahunLabel': '年份',
  'project.tipeBangunan': '建筑类型',
  'project.paketPekerjaan': '工程包',
  'project.lantai': '楼层',
  'project.luasBangunan': '建筑面积',
  'project.jumlahUnit': '单元数量',
  'project.prevPhoto': '上一张',
  'project.nextPhoto': '下一张',
  'featured.showcase': '在建项目',
  'featured.proyek': '项目',
  'featured.unggulan': '进行中',
  'featured.lihatSemua': '查看所有项目',
  'featured.detailProyek': '项目详情',
  'featured.selesai': '已竣工',

  // === LAIN-LAIN / BADGES ===
  'badge.lpjk': '资质认证',
  'badge.iso': 'ISO 9001:2015',
  'badge.sbu': 'SBU认证',
  'sbu.41011': '41011 – 住宅建筑施工',
  'sbu.41012': '41012 – 办公楼施工',
  'sbu.41013': '41013 – 工业建筑施工',
  'sbu.41014': '41014 – 商业建筑施工',
  'sbu.41015': '41015 – 医疗建筑施工',
  'sbu.41017': '41017 – 酒店建筑施工',
  'sbu.41019': '41019 – 宗教场所施工',
};

export default translations;